import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail, paramCheck } from '../utils';

export interface SaveBase64ImageOption extends Partial<GeneralInvokeOption> {
  base64: string;
  invalidParamObj?: string;
}

// 保存图片到相册
export function saveBase64Image(option: SaveBase64ImageOption) {
  if (!option.base64) {
    return logErrorAndRunFail(
      APINames.Native.SAVE_BASE64_IMAGE,
      option,
      'parameter error:parameter.base64 should be String instead of Undefined.'
    );
  }
  if (paramCheck(APINames.Native.SAVE_BASE64_IMAGE, option, { base64: '' })) {
    return MacleJSBridge.beforeInvoke(
      APINames.Native.SAVE_BASE64_IMAGE,
      option
    );
  }
  return option.invalidParamObj;
}
